import { AfterViewInit, Component, EventEmitter, Output, QueryList, TemplateRef, ViewChildren } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { PoprPriority } from '../../../shared/components/popr/popr-priority.enum';
import { PoprService } from '../../../shared/components/popr/popr.service';

@Component({
  selector: 'wpro-popr-toast-laboratory',
  templateUrl: './popr-toast-laboratory.component.html',
  standalone: false
})

export class PoprToastLaboratoryComponent implements AfterViewInit {
  @Output()
  toastEvent = new EventEmitter<{ [key: string]: string }>();

  @ViewChildren('poprTemplate', { read: TemplateRef }) toastTemplateRefs: QueryList<TemplateRef<any>>;

  readonly priorities = Object.values(PoprPriority).filter(value => typeof value === 'string');

  readonly toastPriorityControl = new UntypedFormControl(PoprPriority[PoprPriority.NONE]);
  readonly toastTitleControl = new UntypedFormControl();
  readonly toastTypeControl = new UntypedFormControl('text');
  readonly toastMessageControl = new UntypedFormControl();
  readonly toastTemplate = new UntypedFormControl();
  readonly toastButtonLabelControl = new UntypedFormControl();
  readonly toastButtonUrlControl = new UntypedFormControl();
  readonly toastFormGroup = new UntypedFormGroup({
    priority: this.toastPriorityControl,
    title: this.toastTitleControl,
    type: this.toastTypeControl,
    message: this.toastMessageControl,
    buttonLabel: this.toastButtonLabelControl,
    buttonUrl: this.toastButtonUrlControl
  });

  constructor(
    private poprService: PoprService
  ) { }

  ngAfterViewInit(): void {
    this.toastTemplate.setValue(this.toastTemplateRefs.first);
  }

  cancelAllPoprs(): void {
    this.poprService.clear();
  }

  buildToast(): void {
    this.poprService.createToast(
      PoprPriority[this.toastPriorityControl.value] as any,
      this.messageOrTemplate,
      this.toastTitleControl.value,
      this.toastButtonLabelControl.value,
      this.toastButtonUrlControl.value
    );
    this.toastEvent.emit(this.toastFormGroup.getRawValue());
  }

  get messageOrTemplate(): string | TemplateRef<any> {
    return this.toastTypeControl.value === 'text'
      ? this.toastMessageControl.value
      : this.toastTemplateRefs.toArray()[this.toastTemplate.value];
  }
}
